import React from "react";

import { Group } from "@visx/group";

import { Line } from "../components/Line";

import type { XYChartLinesProps } from "./types";

const XYChartLines = ({
  data,
  getLeftPoint,
  getRightPoint,
  coloursScale,
  lineGradientsScale,
  hoveredLegendItem,
  leftScale,
  rightScale,
  legendItems,
  ...commonChartProps
}: XYChartLinesProps) => {
  return (
    <Group>
      {data?.map(({ data: lineData, axis, label, isGradient }, index) => {
        const colour = coloursScale(label);
        const gradientColour = lineGradientsScale(label);

        return (
          <Line
            key={`line-chart-${index}`}
            {...commonChartProps}
            data={lineData}
            getSidePoint={axis === "left" ? getLeftPoint : getRightPoint}
            colour={
              hoveredLegendItem !== undefined && hoveredLegendItem !== label
                ? `${colour}25`
                : colour
            }
            areaColour={
              isGradient &&
              legendItems?.filter(({ variant }) => variant !== "threshold")
                ?.length === 1
                ? gradientColour
                : undefined
            }
            sideScale={axis === "left" ? leftScale : rightScale}
          />
        );
      }, [])}
    </Group>
  );
};

export default XYChartLines;
